import { render, staticRenderFns } from "./GroupMember.vue?vue&type=template&id=5ba4b89e&scoped=true&"
import script from "./GroupMember.vue?vue&type=script&lang=js&"
export * from "./GroupMember.vue?vue&type=script&lang=js&"
import style0 from "./GroupMember.vue?vue&type=style&index=0&id=5ba4b89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba4b89e",
  null
  
)

export default component.exports